module.exports = __webpack_public_path__ + "static/img/web_7_activities - Original .4308cc50.jpg";